<template>
  <div class="d-table h-100 w-100">
    <div class="row pdp-datebox">
      <div class="col-12">
        <h6 class="pdp-datebox-month text-center text-uppercase text-small font-weight-bold text-medium mb-0">
          {{ monthFilter(date) }}
        </h6>
      </div>
      <div class="col-6">
        <h5 class="pdp-datebox-day text-right text-uppercase font-weight-bold text-medium">
          {{ dayFilter(date) }}
        </h5>
      </div>
      <div class="col-6">
        <h6 class="pdp-datebox-year text-left text-uppercase text-sm font-weight-bold text-medium">
          {{ yearFilter(date) }}
        </h6>
      </div>
    </div>
  </div>
</template>
<script>
import { yearFilter, monthFilter, dayFilter } from "@/services/filters";

export default {
  props: {
    date: { type: String, required: true },
  },
  methods: {
    yearFilter,
    monthFilter,
    dayFilter,
  },
};
</script>
